import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from '@chakra-ui/react';
import {
  updateDoc,
  doc,
} from 'firebase/firestore';
import { db } from '../../firebase/config';
import CreditSelector from './CreditSelector';

const CreditManagementModal = ({ isOpen, onClose, media, onMediaUpdate }) => {
  const [creditInfo, setCreditInfo] = useState({
    creditProfileId: media?.creditProfileId || null,
    credits: media?.credits || null,
  });
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (media) {
      setCreditInfo({
        creditProfileId: media.creditProfileId || null,
        credits: media.credits || null,
      });
    }
  }, [media]);

  const handleSave = async () => {
    if (!media?.id) {
      toast({
        title: 'Error',
        description: 'Media ID is missing.',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    setIsSaving(true);
    try {
      const mediaRef = doc(db, 'site_media', media.id);
      await updateDoc(mediaRef, {
        credits: creditInfo.credits,
        creditProfileId: creditInfo.creditProfileId,
      });

      toast({
        title: 'Credits Updated',
        status: 'success',
        duration: 2000,
      });
      onMediaUpdate({ ...media, ...creditInfo });
      onClose();
    } catch (error) {
      toast({
        title: 'Error updating credits',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Manage Image Credits</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <CreditSelector
            onCreditChange={setCreditInfo}
            initialProfileId={creditInfo.creditProfileId}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            colorScheme="blue"
            ml={3}
            onClick={handleSave}
            isLoading={isSaving}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreditManagementModal;
